import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'grant-categories';

export function useGetAllGrantCategories(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetGrantCategory(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateGrantCategory() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateGrantCategory({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteGrantCategory({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
